<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-xm(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-10
      .column
        p.u-text-lg {{$t('mantraDesc')}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-xm(:title="$t('sec1')" tag="h2")
    .grid.is-tablet-6
      .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
        p {{ item }}


  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}


  section.u-mt-md
    AppTitle.u-mb-mi(:title="$t('sec3')" tag="h2")

    .grid.is-desktop-4.is-tablet-6
      .column.u-mb-sm(v-for="item,idx in $t('sec3Items')")
        h4 {{item.name}}


  section.u-mt-md.u-mb-md
    AppLink(to="/contact" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Big data and analytics meetup",
    "pageDesc":"Gathering data engineers for a meetup of insights and new strategies for utilizing your business data.",
    "mantra":"Big data and| analytics meetup.",
    "mantraDesc":"The future is all about data. And in a world where ambiguity is leading, businesses that can leverage on what they have earlier will take the lead in the digital era. With insights and numbers, acceleration and decision making processes are much easier.",
    "sec1":"Why we are holding this meetup?",
    "sec1Items":{
      "1":"We would love to empower organizations and individuals to better leverage the data in their hands and overcome business challenges through insights. From Machine learning, blockchain to IoT, we hold conversations of possible solutions for automation.",
      "2":"In addition, we would love to host a place where data and analytics enthusiasts can meet and prepare for initiatives and take discussions to further circles and pass knowledge to other community members."
    },
    "sec2":"The meetup agenda",
    "sec2Items":{
      "1":{
        "title":"Data driven decision",
        "desc":"Evolve your operations to be a data driven organization and integrate machine learning with your analytics strategy."
      },
      "2":{
        "title":"Business innovation ",
        "desc":"Be data driven in your innovation endeavours and build a portfolio of analytics on your industry, products and customers behaviors."
      },
      "3":{
        "title":"Business value acceleration",
        "desc":"Discover new opportunities for building value in your operations and monetize your data science efforts."
      }
    },
    "sec3":"Meetup |speakers",
    "sec3Items":{
      "1":{
        "name":"Mostafa Wahba"
      },
      "2":{
        "name":"Ahmed Alaa"
      },
      "3":{
        "name":"Mohamed Ahmed"
      }
    },
    "cta":"Registration will <br> be open soon."
  },
  "ar": {
    "pageTitle":"ملتقى البيانات الضخمة والتحليلات",
    "pageDesc":"من خلال ملتقى البيانات الضخمة والتحليلات نتعرف على رؤى واستراتيجيات جديدة من أجل استخدام البيانات بشكل صحيح في عملك.",
    "mantra":"ملتقى البيانات |الضخمة والتحليلات.",
    "mantraDesc":"المستقبل هو كل شيء حول البيانات. في ظل الغموض الذي يهيمن على العالم اليوم، ستتولي الشركات التي يمكنها التأثير زمام المبادرة في العصر الرقمي. من خلال الأفكار والأرقام أصبحت عمليات التسارع واتخاذ القرارات أسهل من ذي قبل.",
    "sec1":"لماذا نعقد هذا الملتقى؟",
    "sec1Items":{
      "1":"نود تمكين المؤسسات والأفراد من خلال الاستفادة بأفضل شكل من البيانات التي يمتلكونها، والتغلب على تحديات العمل التي تواجههم عن طريق الرؤى. من التعلم الآلي والبلوك تشين إلى إنترنت الأشياء، نجري محادثات شاملة حول الحلول الممكنة للأتمتة.",
      "2":"بالإضافة إلى ذلك، نود أن نستضيف مكانًا يساعد محبي البيانات الضخمة والتحليلات من التواصل سويًا، والتحضير للمبادرات، والانتقال بالمناقشات إلى مستويات أخرى، ونقل المعرفة إلى أفراد المجتمع الآخرين."
    },
    "sec2":"أجندة الملتقى",
    "sec2Items":{
      "1":{
        "title":"القرارات قائمة على البيانات",
        "desc":"طور عملياتك لتكون أكثر تنظيمًا واعتمادًا على البيانات، وادمج ما بين التعلم الآلي واستراتيجيات التحليلات الخاصة بك."
      },
      "2":{
        "title":"ابتكار الأعمال التجارية ",
        "desc":"اجعل أعمالك التجارية مدفوعة بالبيانات من أجل السعى نحو الابتكار وقم ببناء التحليلات حول كل من الصناعة والمنتجات وسلوكيات العملاء."
      },
      "3":{
        "title":"تسارع القيمة",
        "desc":"اكتشف المزيد من الفرص الجديدة من أجل بناء القيمة في عملياتك وتحقيق الدخل من الجهود في علوم البيانات."
      }
    },
    "sec3":"متحدثو |الملتقى",
    "sec3Items":{
      "1":{
        "name":"مصطفي وهبة"
      },
      "2":{
        "name":"أحمد علاء"
      },
      "3":{
        "name":"محمد أحمد"
      }
    },
    "cta":"التسجيل سوف يكون <br> متاح قريبًا"
  }
}
</i18n>
